export interface FileMutation {
  path: string;
  diff: string;
  kind?: string;
  movePath?: string;
}

export interface FileMutationToolInput {
  file_mutations?: unknown;
}

function readString(value: unknown): string | undefined {
  if (typeof value !== 'string') return undefined;
  const normalized = value.trim();
  return normalized.length > 0 ? normalized : undefined;
}

function toFileMutation(candidate: unknown): FileMutation | null {
  if (!candidate || typeof candidate !== 'object') return null;

  const record = candidate as Record<string, unknown>;
  const path = readString(record.path) ?? readString(record.file_path);
  const diff = readString(record.diff);
  if (!path || !diff) return null;

  const kindValue = record.kind;
  let kind = readString(kindValue);
  let movePath = readString(record.move_path) ?? readString(record.movePath);
  if (kindValue && typeof kindValue === 'object') {
    const kindRecord = kindValue as Record<string, unknown>;
    kind = kind ?? readString(kindRecord.type);
    movePath = movePath ?? readString(kindRecord.move_path) ?? readString(kindRecord.movePath);
  }

  return {
    path,
    diff,
    ...(kind ? { kind } : {}),
    ...(movePath ? { movePath } : {}),
  };
}

export function normalizeFileMutations(value: unknown): FileMutation[] {
  if (!Array.isArray(value)) return [];
  const result: FileMutation[] = [];
  for (const candidate of value) {
    const mutation = toFileMutation(candidate);
    if (mutation) result.push(mutation);
  }
  return result;
}

export function extractFileMutationsFromToolInput(
  input?: FileMutationToolInput | Record<string, unknown>,
): FileMutation[] {
  if (!input) return [];
  if (Array.isArray(input.file_mutations)) {
    return normalizeFileMutations(input.file_mutations);
  }
  return [];
}
